import React from 'react';
import { Auth } from 'aws-amplify';
import { Redirect } from 'react-router-dom';
import { LOGIN } from 'navigation/PageUrls';

const Logout = () => {
  Auth.signOut();
  return <Redirect to={LOGIN} />;
};

export default Logout;
